<template>
  <div class="flex items-center justify-center py-px">
    <!-- Dropdown Menu -->
    <div class="flex items-center justify-center">
      <button
        class="w-8 h-8 rounded-full border border-gray-300 shadow-sm"
        :class="$deviceStore.isMobile ? '' : 'hover:scale-[1.1] hover:translate-y-[-3px] duration-300'"
        @click="toggleDropdown"
      >
        <img
          :src="getSelectedFlag()"
          :alt="getSelectedLanguageName()"
          class="w-full h-full rounded-full object-cover select-none"
        />
      </button>
    </div>

    <!-- Invisible Overlay -->
    <BackPanel
      v-if="dropdownOpen"
      class="!z-[998]"
      @click="closeDropdown"
    ></BackPanel>

    <!-- Dropdown List -->
    <div
      v-if="dropdownOpen"
      class="absolute right-0 bg-white border border-gray-300 rounded-lg shadow-lg z-[999]"
      :class="$deviceStore.isMobile ? 'top-[50px]' : 'top-[60px]'"
    >
      <ul class="flex flex-col space-y-2 p-2">
        <li
          v-for="language in filteredLanguages"
          :key="language.code"
          class="flex items-center cursor-pointer hover:bg-gray-100 p-2 rounded duration-300 hover:scale-[1.1] hover:translate-y-[-3px]"
          @click="selectLanguage(language.code)"
        >
          <img
            :src="language.flag"
            :alt="language.name"
            class="w-8 h-8 rounded-full object-cover select-none"
          />
          <span class="ml-2 text-sm font-semibold select-none">
            <Translate :value="language.name" class="w-full" />
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import StorageHandler from "@/utils/StorageHandler.js";
import BackPanel from "@/components/Blocks/BackPanel.vue";

export default {
  name: "LanguageSelector",
  components: {
    BackPanel,
  },
  data() {
    return {
      dropdownOpen: false
    };
  },
  computed: {
    languageStore() {
      return this.$languageStore;
    },
    selectedLanguage() {
      return this.languageStore.selectedLanguage;
    },
    filteredLanguages() {
      return this.$languageStore.languages.filter(
        (language) =>
          language.code !== this.selectedLanguage?.code
      );
    },
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    closeDropdown() {
      this.dropdownOpen = false;
    },
    async selectLanguage(code) {
      this.closeDropdown(); // Close the dropdown after selection
      const selected = this.$languageStore.languages.find(
        (language) => language.code === code
      );
      if (selected) {
        // Update the language store
        this.$languageStore.setLanguage(selected);
        StorageHandler.InsertSessionStorage(
          "selectedLanguage",
          selected
        );
        StorageHandler.RemoveSessionStorageAll(["user", "selectedLanguage"]);
        // Fetch updated headers based on the new language
        await this.$headerStore.fetchHeaders(selected.alternative || selected.code);
        this.$router.go();
      }
    },
    getSelectedFlag() {
      return this.selectedLanguage?.flag || "";
    },
    getSelectedLanguageName() {
      return this.selectedLanguage?.name || "";
    }
  },
  mounted() {
    // If no language was stored, set default to the first language in the list
    if (!this.$languageStore.selectedLanguage) {
      this.$languageStore.setLanguage(this.$languageStore.languages[0]);
    }
  },
};
</script>